/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetTransactionByIdOptions,
  GetTransactionByIdResponses,
} from '../types/GetTransactionById'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get a transaction by ID
 * {@link /v1/transactions/:transaction_id}
 */
export function getTransactionById<ThrowOnError extends boolean = true>(
  options: Options<GetTransactionByIdOptions, ThrowOnError>,
): Unwrappable<RequestResult<GetTransactionByIdResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/transactions/{transaction_id}',
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetTransactionByIdResponses, ThrowOnError>>,
  )
}
